import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-title" }
const _hoisted_2 = { class: "page-title__inner container" }
const _hoisted_3 = { class: "page-title__title" }


export default /*@__PURE__*/_defineComponent({
  __name: 'PageTitle',
  props: {
    title: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(__props.title), 1),
      _renderSlot(_ctx.$slots, "actions")
    ])
  ]))
}
}

})